<template>
  <div class="materials-stories">
    <materials-stories-modal
      v-if="modal"
      :stories="stories"
      :start-story-index="currentStoryIndex"
      @close="modal = false"
    />

    <button
      v-for="(story, index) in stories"
      :key="index"
      class="m-btn"
    >
      <img
        :src="story.img"
        :alt="story.text"
        loading="lazy"
        @click="openModal(index)"
      >

      <span>{{ story.text }}</span>
    </button>
  </div>
</template>

<script>
import MaterialsStoriesModal from './MaterialsStoriesModal.vue';

export default {
  name: 'MaterialsStories',
  components: { MaterialsStoriesModal },
  data: () => ({
    modal: false,
    currentStoryIndex: 0,
    stories: [
      {
        id: 1,
        img: '/img/materials/stories/school.webp',
        text: 'школа',
        videos: [
          {
            src: '/img/materials/stories/school-1.mp4',
            link: '/online-school',
            text: 'познакомиться со школой',
            duration: 54,
          },
          {
            src: '/img/materials/stories/school-2.mp4',
            link: '/online-school',
            text: 'познакомиться со школой',
            duration: 21,
          },
          {
            src: '/img/materials/stories/school-3.mp4',
            link: '/online-school',
            text: 'познакомиться со школой',
            duration: 14,
          },
        ],
      },
      {
        id: 2,
        img: '/img/materials/stories/events.webp',
        text: 'ивенты',
        videos: [
          { src: '/img/materials/stories/events-1.mp4', duration: 30 },
          { src: '/img/materials/stories/events-2.mp4', duration: 21 },
        ],
      },
      {
        id: 3,
        img: '/img/materials/stories/mems.webp',
        text: 'мемы',
        videos: [
          { src: '/img/materials/stories/mems-1.mp4', duration: 12 },
          { src: '/img/materials/stories/mems-2.mp4', duration: 13 },
          {
            src: '/img/materials/stories/mems-3.mp4',
            link: '/itogovoe-sochinenie',
            text: 'перейти к курсу',
            duration: 20,
          },
          { src: '/img/materials/stories/mems-4.mp4', duration: 6 },
          { src: '/img/materials/stories/mems-5.mp4', duration: 7 },
        ],
      },
      {
        id: 4,
        img: '/img/materials/stories/reviews.webp',
        text: 'отзывы',
        videos: [
          { src: '/img/materials/stories/reviews-1.mp4', duration: 50 },
          { src: '/img/materials/stories/reviews-2.mp4', duration: 35 },
          {
            src: '/img/materials/stories/reviews-3.mp4',
            link: '/free/ege/kurs-ege-2024',
            text: 'бесплатный курс егэ',
            duration: 34,
          },
          { src: '/img/materials/stories/reviews-4.mp4', duration: 22 },
        ],
      },
      {
        id: 5,
        img: '/img/materials/stories/discount.webp',
        text: 'скидки',
        videos: [
          {
            src: '/img/materials/stories/discount.mp4',
            link: '/ege',
            text: 'скидка на годовой курс',
            duration: 34,
          },
        ],
      },
    ],
  }),
  methods: {
    openModal(storyIndex) {
      this.currentStoryIndex = storyIndex;
      this.modal = true;
    },
  },
};
</script>

<style scoped lang="scss">

.materials-stories {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(var(--scale) * 12);
  padding: calc(var(--scale) * 2);
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  @include media-down($size-mobile) {
    justify-content: flex-start;
    width: calc(100% + var(--scale) * 24);
    padding-inline: calc(var(--scale) * 12);
    margin-left: calc(-1 * var(--scale) * 12);
  }

  button {
    img {
      margin-bottom: calc(var(--scale) * 4);
      display: block;
      border: calc(var(--scale) * 3) solid transparent;
      border-radius: 50%;
      width: calc(var(--scale) * 90);
      aspect-ratio: 1 / 1;
      outline: calc(var(--scale) * 2) solid #FF5319;
    }

    span {
      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      text-align: center;
      color: #02120F;
    }
  }
}

</style>
